import React from 'react';
import { Button } from '@mui/material';
import { Check, Remove } from '@mui/icons-material';

interface CheckboxWithIndeterminateProps {
  checked: boolean;
  indeterminate?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  customSx?: Object;
}

const CheckboxWithIndeterminate: React.FC<CheckboxWithIndeterminateProps> = ({
  checked,
  indeterminate = false,
  onClick,
  customSx,
}) => {
  const isFilled = checked || indeterminate;

  return (
    <Button
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #2F736E',
        borderRadius: '4px',
        minWidth: '20px',
        padding: 0,
        height: '20px',
        width: '20px',
        backgroundColor: isFilled ? '#2F736E' : 'transparent',
        '&:hover': {
          backgroundColor: isFilled ? '#2F736E' : 'transparent',
        },
        ...customSx,
      }}
      disableRipple
    >
      {indeterminate ? (
        <Remove
          style={{
            height: '16px',
            width: '16px',
            color: '#FFFFFF',
          }}
        />
      ) : (
        <Check
          style={{
            height: '16px',
            width: '16px',
            color: '#FFFFFF',
            display: checked ? 'block' : 'none',
          }}
        />
      )}
    </Button>
  );
};

export default CheckboxWithIndeterminate;
